import React from "react";
import styled from "styled-components";

const HeroTitleStyled = styled.div.attrs({
  className: "u-col-center u-items-center u-w100 u-fullpage",
})`
  background-color: #009ace;
  
  /* スクロールスナップの設定 */
  scroll-snap-align: start;
`;

const OsBrandName = () => {
  return (
    <HeroTitleStyled>
      <div className="heading-spacing-1824 u-text-center u-text-white slideup-center">
        soremo OS
      </div>
    </HeroTitleStyled>
  );
};

export default OsBrandName;
